/** Status + quality filter options (Meta-style). Keys map to server SQL. */
export const TEMPLATE_STATUS_FILTER_OPTIONS = [
  { id: "active_high", label: "Active – High quality" },
  { id: "active_low", label: "Active – Low quality" },
  { id: "active_quality_pending", label: "Active – Quality pending" },
  { id: "active_medium", label: "Active – Medium quality" },
  { id: "appealed_in_review", label: "Appealed – In review" },
  { id: "paused", label: "Paused" },
  { id: "in_review", label: "In review" },
  { id: "rejected", label: "Rejected" },
  { id: "archived", label: "Archived" },
  { id: "disabled", label: "Disabled" },
];

export const TEMPLATE_TIME_RANGE_OPTIONS = [
  { id: null, label: "All time" },
  { id: 7, label: "Last 7 days" },
  { id: 30, label: "Last 30 days" },
  { id: 60, label: "Last 60 days" },
  { id: 90, label: "Last 90 days" },
];

export const CATEGORY_LABELS = {
  MARKETING: "Marketing",
  UTILITY: "Utility",
  AUTHENTICATION: "Authentication",
};

export function getCategoryLabel(category) {
  if (!category) return category;
  const key = String(category).toUpperCase();
  return CATEGORY_LABELS[key] || category;
}
